import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { motion } from 'framer-motion';
export function Testimonials() {
  const testimonials = [{
    text: 'Hice mi primer pedido de 10 docenas para una fiesta de 15 años. Gané más en un fin de semana que en dos semanas de trabajo.',
    author: 'Mariela G.',
    location: 'Córdoba'
  }, {
    text: 'La técnica de humectación del Tomo I cambió todo. Mis sándwiches duran 48 horas húmedos y frescos. Los clientes no pueden creerlo.',
    author: 'Laura P.',
    location: 'Rosario'
  }, {
    text: 'Los guiones de WhatsApp me salvaron. Antes no sabía qué responder cuando me pedían precio. Ahora cierro el 80% de las consultas.',
    author: 'Patricia M.',
    location: 'Buenos Aires'
  }];
  const scrollImages = ['https://cdn.magicpatterns.com/uploads/kMhLDgNQTu9zLU9VZtn866/_Sandwich_Triple__(de_Charlotte)__Charlotte_es_una_cadena_de_cafeterias_gourmet_donde_diariamente_uno_puede_disfrutar_de_una_deliciosa_comida_y_los_mas_variados_postres_de_Lima_.jpg', 'https://cdn.magicpatterns.com/uploads/e1sNhkAtcLt4yniXhJrRKw/Tea_club_sandwiches__Sanguchitos_de_miga_Comida_Argentina.jpg', 'https://cdn.magicpatterns.com/uploads/nufiQYenV3NLguqsWWmtQa/Los_mejores_sandwiches_de_miga_de_CABA__la_confiteria_emblematica_que_los_prepara_y_su_gran_historia___canal26_com.jpg', 'https://cdn.magicpatterns.com/uploads/3BTrw36DZkvfJSAgrwyBYH/I_prepared_them_today_with_my_friend_the_baker.jpg'];
  // Duplicate images for seamless loop
  const duplicatedImages = [...scrollImages, ...scrollImages];
  return <section className="py-12 bg-brand-lightGray" data-id="element-360">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-361">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-brand-dark mb-8" data-id="element-362">
          LO QUE DICEN NUESTRAS CLIENTAS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-363">
          {testimonials.map((t, idx) => <motion.div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} data-id="element-364">
              <div className="flex text-brand-gold mb-4" data-id="element-365">
                {[...Array(5)].map((_, i) => <StarIcon key={i} data-id="element-366" />)}
              </div>
              <p className="text-brand-gray text-lg italic mb-4 flex-grow" data-id="element-367">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-368">
                <p className="font-bold text-brand-dark" data-id="element-369">{t.author}</p>
                <p className="text-sm text-brand-gray" data-id="element-370">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Continuous scrolling image marquee */}
      <div className="mt-10 overflow-hidden" data-id="element-371">
        <style data-id="element-372">{`
          @keyframes marquee-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
        <div className="flex gap-6" style={{
        animation: 'marquee-scroll 20s linear infinite',
        width: 'max-content'
      }} data-id="element-373">
          {duplicatedImages.map((src, idx) => <div key={idx} className="flex-shrink-0 w-64 h-48 rounded-xl overflow-hidden shadow-md" data-id="element-374">
              <img src={src} alt="Sándwiches de miga" className="w-full h-full object-cover" data-id="element-375" />
            </div>)}
        </div>
      </div>
    </section>;
}